import { Task, TaskType } from "../redux/type";
import { API } from "../utils/constants";

export const getTaskByName = (name: string) => {
  switch (name) {
    case TaskType.DECODER:
      return "Decoder";
    case TaskType.LOREKEEPER:
      return "Lorekeeper";
    case TaskType.SIGNAL_BOOSTER:
      return "Signal Booster";
    case TaskType.FEED_WATCHER:
      return "Feed Watcher";
    case TaskType.NETWORKING_EVENT:
      return "Networking Event";
    case TaskType.UI_UX_ARCHITECT:
      return "UI/UX Architect";
    case TaskType.INTERFACE_ARCHITECT:
      return "Interface Architect";
    case TaskType.SYSTEM_BUILDER:
      return "System Builder";

    // case TaskType.CATCH_UP:
    // return "Catch Up";

    default:
      return "Unknown";
  }
};

export const getInstructionByName = (name: string) => {
  switch (name) {
    case TaskType.DECODER:
      return "Take a screenshot (image) of the moment the loop resets. Mark what repeats and add a short 1–2 line insight.";
    case TaskType.LOREKEEPER:
      return `Write a brief story log entry titled "The Loop of Trust" with the timestamp and your interpretation.`;
    case TaskType.SIGNAL_BOOSTER:
      return "Create a short GIF or video of the loop. Add the caption “Would you trust a loop that hides its reset?” and use #GridLoop.";
    case TaskType.FEED_WATCHER:
      return "Write a short 2–3 sentence reflection about something repetitive or controlled in real life — like déjà vu, loyalty programs, or algorithmic feeds.";
    case TaskType.NETWORKING_EVENT:
      return "Join the networking event to connect with others.";
    case TaskType.UI_UX_ARCHITECT:
      return "Create a short GIF or video of the loop. Add the caption “Would you trust a loop that hides its reset?” and use #GridLoop.";
    case TaskType.INTERFACE_ARCHITECT:
      return "Create a short GIF or video of the loop. Add the caption “Would you trust a loop that hides its reset?” and use #GridLoop.";
    case TaskType.SYSTEM_BUILDER:
      return "Create a short GIF or video of the loop. Add the caption “Would you trust a loop that hides its reset?” and use #GridLoop.";
    // case TaskType.CATCH_UP:
    // return "Catch up on missed activities.";

    default:
      return "No instructions available.";
  }
};

export const addTask = async (taskData: {
  title: string;
  description: string;
  type: TaskType;
  isActive: boolean;
  xpReward: number;
  timeReward: number;
  uid: string;
}): Promise<{ error?: string; data?: Task }> => {
  try {
    const response = await fetch(API + "/admin/addTask", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(taskData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      return { error: errorData.error || "Failed to add task" };
    }

    return await response.json();
  } catch (error) {
    return {
      error:
        error instanceof Error
          ? error.message
          : "Network error while adding task",
    };
  }
};

export const getTasksApi = async (uid: string): Promise<Task[] | null> => {
  try {
    const response = await fetch(API + "/tasks/getTasks", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ uid }),
    });
    const data = await response.json();
    if (data.error) return null;
    return data.tasks || data;
  } catch (error) {
    console.error("Error fetching tasks:", error);
    return null;
  }
};

export const getAllTasks = async (uid: string): Promise<Task[] | null> => {
  try {
    const response = await fetch(API + "/admin/getTasks", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ uid }),
    });
    const data = await response.json();
    if (data.error) return null;
    return data.tasks || data;
  } catch (error) {
    console.error("Error fetching all tasks:", error);
    return null;
  }
};

export const updateTask = async (
  taskId: string,
  taskData: Partial<Task>
): Promise<Task | null> => {
  const response = await fetch(API + "/admin/editTask", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ taskId, ...taskData }),
  });

  const data = await response.json();
  if (data.error) return null;
  return data;
};

export const deleteTask = async (
  taskId: string,
  uid: string
): Promise<boolean> => {
  const response = await fetch(API + "/admin/deleteTask", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ taskId, uid }),
  });

  const data = await response.json();

  return data;
};

// Optional: keep if checkTaskCompletion is still in use
export const checkTaskApi = async (
  uid: string,
  taskId: string,
  content: string
) => {
  const response = await fetch(API + "/checkTaskCompletion", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ taskId, uid, content }),
  });
  return await response.json();
};
